import { Navigate, Outlet } from "react-router-dom";
import { roleCheck } from "../lib/roleCheck";
import { getDefaultPagePerRole } from "../lib/roleBasedDefaultPage";

type ProtectedSubRouteBoProps = {
  allowedRoles: string[];
  role: string;
};

export const ProtectedSubRoute = ({ role, allowedRoles }: ProtectedSubRouteBoProps) => {
  if (!roleCheck(allowedRoles, role)) {
    return <Navigate to={getDefaultPagePerRole(role)} />;
  }
  return <Outlet />;
};
